(function () {
  'use strict';

  angular
    .module('web2print.shared')
    .directive('featureToggler', featureToggler);

  /* @ngInject */
  function featureToggler () {
    const directive = {
      restrict: 'E',
      templateUrl: 'components/shared/feature-toggler/feature-toggler.html',
      scope: {
        isOpen: '='
      },
      link: linkFunc,
      controller: FeatureTogglerController,
      controllerAs: 'vm',
      bindToController: true
    };

    return directive;

    function linkFunc (scope, el, attr, ctrl) {

    }
  }

  FeatureTogglerController.$inject = ['$localStorage', '$state', '$stateParams', '$timeout', '$window',
    'FeatureToggleFactory'];

  /* @ngInject */
  function FeatureTogglerController ($localStorage, $state, $stateParams, $timeout, $window, FeatureToggleFactory) {
    const vm = this;

    vm.close = close;
    vm.reload = reload;
    vm.toggleFeature = FeatureToggleFactory.toggleFeature;

    $window.openFeatureToggler = openFeatureToggler;

    activate();

    //////////////

    function activate () {
      vm.features = FeatureToggleFactory.getFeatures();

      if (web2print.env.enableFeatureToggle && $stateParams.toggleFeatures && $stateParams.toggleFeatures === 'true') {
        openFeatureToggler();
      }
    }

    function openFeatureToggler () {
      $timeout(function () {
        vm.isOpen = true;
      }, 0);
    }

    function close () {
      vm.isOpen = false;
    }

    function reload () {
      delete $stateParams.toggleFeatures;
      $state.reload();
    }
  }
})();
